var module = angular.module('octopusApp.tasks');

module.controller("LetsEncryptDialogController", function($scope, $injector, $uibModalInstance, busy, octopusRepository, octoDialog, $location, letsEncryptConfiguration, configSettings) {
  var isSaving = $scope.isSaving = busy.create();
  var vm = this;

  vm.httpsPortFieldEnabled = function() {
    return vm.binding != null && !vm.binding.startsWith('http://');
  };

  vm.bindingChanged = function() { 
    if (!vm.binding)
      return;

    var urlParts = vm.binding.split(':');
    vm.letsEncryptConfiguration.DnsName = urlParts[1].replace(/\//g,"");
    if (vm.binding.startsWith('https://')) {
      if (urlParts.length == 2) {
        vm.letsEncryptConfiguration.HttpsPort = 443;
      } else {
        vm.letsEncryptConfiguration.HttpsPort = urlParts[2];
      }
    } else {
      vm.letsEncryptConfiguration.HttpsPort = 443;
    }
  };

  vm.close = function() {
    $uibModalInstance.close();
  };

  var getHttpUrl = function(url) {
    var urlParts = url.split(':');
    var dnsName = urlParts[1].replace(/\//g,"");
    return "http://" + dnsName;
  }

  var isServerListeningOnHttp = function (url) {
    var httpUrl = getHttpUrl(url);
    return vm.bindings.filter(function(binding) { return binding.replace(/\/$/g, "") == httpUrl; }).length > 0;
  }

  vm.register = function() {
    var url = getListenPrefix(vm.letsEncryptConfiguration);
    var httpUrl = getHttpUrl(url);
    if (httpUrl === "http://localhost" || httpUrl === "http://127.0.0.1") {
      octoDialog.alertMessageBox({
          title: 'Cannot use localhost',
          message: "Let's Encrypt cannot use localhost as the binding. Let's Encrypt needs to communicate with the Octopus Portal to validate domain control.<br><br>Please select a non-localhost binding."
      });      
    } 
    else if (!isServerListeningOnHttp(url)) {
      octoDialog.asyncConfirm({
          title: 'Not listening on HTTP port 80',
          message: "The Octopus Portal is not currently listening on <a href='" + httpUrl + "'>" + httpUrl + "</a> on port 80. Let's Encrypt communicates with the Portal over the HTTP protocol to validate domain control.<br><br>Please cancel and use the Octopus Server Manager to setup a HTTP binding for this url.",
          executeButtonText: "Continue Anyway",
          execute: function(dialog) {
            createTask('Configure Let\'s Encrypt SSL Certificate');
            dialog.dismiss();
          }
      });      
    } 
    else if (willCauseServerRestart(url)) {
      octoDialog.asyncConfirm({
          title: 'Restart server?',
          message: "Applying the new certificate from Let's Encrypt will require a restart of the Octopus Server, as the Portal is not currently listening on <a href='" + url + "'>" + url + "</a>.<br><br>Are you sure you want to continue?",
          executeButtonClass: "btn-warning",
          executeButtonText: "Continue",
          execute: function(dialog) {
            createTask('Configure Let\'s Encrypt SSL Certificate');
            dialog.dismiss();
          }
      });
    }
    else {
      createTask('Configure Let\'s Encrypt SSL Certificate');
    }
  };

  var getListenPrefixes = function(configSettings) {
    var listenPrefixes = null;
    for(var i = 0; i < configSettings.length; i++) {
      var setting = configSettings[i];
      for(var j = 0; j < setting.ConfigurationValues.length; j++) {
        var configurationValue = setting.ConfigurationValues[j];
        if (configurationValue.Key == "Octopus.WebPortal.ListenPrefixes") {
          listenPrefixes = configurationValue.Value;
        }
      }
    }
    if (listenPrefixes) {
      return bindings = listenPrefixes.split(',')
          .filter(function(prefix) {
            return !!prefix && prefix !== "";
          })
          .map(function(prefix) {
            return prefix.replace(/\/$/, "");
          });
    }
    return [];
  };

  var createTask = function(taskDescription) {
    var task = {
        Name: 'ConfigureLetsEncrypt',
        Description: taskDescription,
        Arguments: { }
    };
    task.Arguments.DnsName = vm.letsEncryptConfiguration.DnsName;
    task.Arguments.RegistrationEmailAddress = vm.letsEncryptConfiguration.RegistrationEmailAddress;
    task.Arguments.AcceptLetsEncryptTermsOfService = vm.letsEncryptConfiguration.AcceptLetsEncryptTermsOfService;
    task.Arguments.HttpsPort = vm.letsEncryptConfiguration.HttpsPort;
    task.Arguments.IPAddress = vm.letsEncryptConfiguration.IPAddress;

    isSaving.promise(octopusRepository.Tasks.create(task).then(function (result) {
      $location.path("/tasks/" + result.Id);
    }));
  };

  var willCauseServerRestart = function(url) {
    return vm.bindings.filter(function(binding) { return binding.toLowerCase() == url.toLowerCase(); }).length == 0;
  };

  var getListenPrefix = function(letsEncryptConfiguration) {
    var url = 'https://' + letsEncryptConfiguration.DnsName;
    if (letsEncryptConfiguration.HttpsPort != 443) {
      url = url + ":" + letsEncryptConfiguration.HttpsPort;
    }
    return url;
  };

  var getDefaultBinding = function(bindings) {
    if (bindings.length == 0)
      return "";
    var httpsBindings = bindings.filter(function(binding) { return binding.startsWith('https://'); });
    if (httpsBindings.length > 0)
      return httpsBindings[0];
    var httpBindings = bindings.filter(function(binding) { return binding.startsWith('http://'); });
    if (httpBindings.length > 0)
      return httpBindings[0];
    return "";
  };

  var init = function() {
    vm.letsEncryptConfiguration = letsEncryptConfiguration;
    vm.configSettings = configSettings;

    var bindings = getListenPrefixes(configSettings);
    vm.binding = getDefaultBinding(bindings);
    vm.bindings = bindings;

    if (vm.letsEncryptConfiguration.DnsName && vm.letsEncryptConfiguration.HttpsPort) {
      vm.binding = getListenPrefix(vm.letsEncryptConfiguration);
    }
    vm.bindingChanged();
  };

  init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/certificates/controllers/lets_encrypt_dialog_controller.js
// module id = 8298298210819772
// module chunks = 1